class Sidetab {
	constructor(el) {
		this.el = el;

		this.el.querySelector('.js--sidetab-trigger').addEventListener('click', this.handleTrigger.bind(this));
		this.el.querySelector('.js--sidetab-close').addEventListener('click', this.handleClose.bind(this));
	}

	handleTrigger() {
		this.el.classList.add('sidetab--open');
	}

	handleClose() {
		this.el.classList.remove('sidetab--open');
	}
}

export default Sidetab
